function getReservePrices() {
  return [
    {
      label: "5-10 Lakh",
      value: "5-10",
    },
    {
      label: "10-15 Lakh",
      value: "10-15",
    },
    {
      label: "15-20 Lakh",
      value: "15-20",
    },
    {
      label: "20-25 Lakh",
      value: "20-25",
    },
    {
      label: "25-50 Lakh",
      value: "25-50",
    },
    {
      label: ">50 Lakh",
      value: ">50",
    },
  ];
}

function getReservePrice(data: any) {
  let prices = getReservePrices();

  return prices.find((item: any) => {
    return item.value === data.slug;
  });
}

export { getReservePrices, getReservePrice };
